<template>
  <div class="form__group">
    <div class="form__field">
      <div class="form__block">
        <slot/>
      </div>
    </div>

    <div class="form__field">
      <a class="button button--secondary" @click="e => $emit('click', e)">
        <span class="button__icon icon-cancel"></span>
      </a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
